import irisApi from 'src/services/iris-api'

export const getMetricById = async <T>(metricId: string, payload: any) => {
  const url = `v1/metrics/${metricId}/explore`

  const { data } = await irisApi.post<T>(url, payload)
  return data
}

export const getMassGuidelineMetricsById = async <T>(metricId: string, payload: any) => {
  const url = `v1/mass-guideline-metrics/${metricId}/explore`

  const { data } = await irisApi.post<T>(url, payload)
  return data
}
